import Icon from "./IconBase.js";
const ClosedIcon = (props) => {
  return (
    <Icon width="31" height="31" viewBox="0 0 31 31" {...props}>
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          width="30"
          height="30"
          rx="15"
          fill="black"
          fillOpacity="0.6"
        />
        <path
          d="M19.9493 20H18.2533L15.5013 15.584L12.7493 20H11.0693L14.6693 14.24L11.2773 8.8H12.9573L15.5013 12.88L18.0453 8.8H19.7253L16.3493 14.224L19.9493 20Z"
          fill="white"
        />
      </svg>
    </Icon>
  );
};
export default ClosedIcon;
